var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAmmex(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39,
    height: 29,
    fill: "none",
    viewBox: "0 0 39 29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mx"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38.214,
    height: 28.791,
    x: 0.763,
    fill: "#fff",
    rx: 2.13
  }), /*#__PURE__*/React.createElement("rect", {
    width: 37.214,
    height: 27.791,
    x: 1.263,
    y: 0.5,
    stroke: "#9DADBC",
    strokeOpacity: 0.36,
    rx: 1.63
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fill: "#2F6EB7",
    d: "M10 5h19v19H10V5Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fill: "#fff",
    d: "M16.914 20.992v-6.809H29v1.9l-1.372 1.478L29 19.091v1.9h-2.217l-1.213-1.319-1.162 1.32h-7.494Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fill: "#2F6EB7",
    d: "M17.706 20.253v-5.33h4.486v1.213h-3.009v.845h2.956v1.213h-2.956v.792h3.009v1.267h-4.486Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    fill: "#2F6EB7",
    d: "m22.192 20.253 2.48-2.692-2.48-2.639h1.9l1.53 1.69 1.53-1.69H29v.053l-2.428 2.586L29 20.147v.106h-1.847l-1.53-1.742-1.584 1.742h-1.847Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    fill: "#fff",
    d: "M17.442 8.114h2.955l1.003 2.322V8.114h3.642l.58 1.742.634-1.742H29v6.808H14.433l3.009-6.808Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    fill: "#2F6EB7",
    d: "m18.022 8.853-2.375 5.33h1.636l.422-1.055h2.428l.422 1.055h1.637l-2.323-5.33h-1.847Zm.211 3.06.686-1.688.687 1.689h-1.373Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    fill: "#2F6EB7",
    d: "M22.192 14.183v-5.33h2.27l1.213 3.272 1.161-3.272H29v5.33h-1.372v-3.641l-1.372 3.641h-1.267l-1.372-3.641v3.641h-1.425Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmmex);
export default __webpack_public_path__ + "static/media/ammex.f6e0d86fcbb71155874a7b5c5bb59112.svg";
export { ForwardRef as ReactComponent };